// extracted by mini-css-extract-plugin
module.exports = {"box":"box-2TqanJ7N","title":"title-3FN9_jz1","line":"line-N-iwsXWx","coor":"coor-wy90dsQ2","item_box":"item_box-kdJfsqvC"};